var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_927_888",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_927_888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5106 35C16.8473 35 15.2988 34.5627 13.8651 33.688C12.4321 32.8127 11.3572 31.5833 10.6404 30H6.2262V27.208H9.64258C9.51482 26.5413 9.44449 25.8747 9.43159 25.208C9.41869 24.5413 9.41224 23.861 9.41224 23.167H6.1875V20.375H9.41224C9.41224 19.653 9.41869 18.9377 9.43159 18.229C9.44449 17.521 9.54031 16.8197 9.71905 16.125H6.2262V13.333H10.7178C11.0759 12.611 11.5301 11.9583 12.0805 11.375C12.6308 10.7917 13.2386 10.3057 13.9038 9.917L11.1011 6.875L12.8673 5L16.3611 8.792C17.0773 8.542 17.8002 8.417 18.53 8.417C19.2591 8.417 19.982 8.542 20.6988 8.792L24.2304 5L25.9966 6.875L23.1939 9.917C23.8597 10.3057 24.4549 10.7917 24.9794 11.375C25.504 11.9583 25.9711 12.611 26.3808 13.333H30.8337V16.125H27.3022C27.4809 16.8197 27.5703 17.521 27.5703 18.229V20.375H30.8337V23.167H27.5703V25.208C27.5703 25.8747 27.5064 26.5413 27.3786 27.208H30.8337V30H26.4186C25.7024 31.6113 24.6275 32.8473 23.1939 33.708C21.7608 34.5693 20.1998 35 18.5106 35ZM18.5106 32.208C20.3023 32.208 21.8315 31.5277 23.098 30.167C24.3652 28.8057 24.9988 27.1527 24.9988 25.208V18.333C24.9988 16.389 24.3652 14.7293 23.098 13.354C21.8315 11.9793 20.3023 11.292 18.5106 11.292C16.7189 11.292 15.1897 11.9793 13.9232 13.354C12.656 14.7293 12.0224 16.389 12.0224 18.333V25.208C12.0224 27.1527 12.656 28.8057 13.9232 30.167C15.1897 31.5277 16.7189 32.208 18.5106 32.208ZM15.4397 26.667H21.5815V23.875H15.4397V26.667ZM15.4397 19.625H21.5815V16.875H15.4397V19.625Z",
    fill: "#2B74E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.323585eea4ea21eb96ff7c6f968588c6.svg";
export { ForwardRef as ReactComponent };